import { render, staticRenderFns } from "./PathSetting.vue?vue&type=template&id=0372f02c&"
import script from "./PathSetting.vue?vue&type=script&lang=ts&"
export * from "./PathSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports